import { User as UserImpl } from "firebase/auth";
export type UserToCreate = UserImpl

export class User {
  getImage(): string | null | undefined {
    return this.payload.photoURL
  }
  getID(): string | null | undefined {
    return this.payload.uid
  }
  getName(): string | null {
    return this.payload.displayName
  }
  constructor(private payload: UserToCreate) {

  }

  async getToken() {
    return this.payload.getIdToken();
  }

  getEmail() {
    return this.payload.email;
  }

}